module.exports = __webpack_public_path__ + "static/media/BETYAR_logo_home.98f8b7a0.png";